// extracted by mini-css-extract-plugin
module.exports = {"garderobo__looks":"ScreenPopularContent_garderobo__looks__1dD82"};